import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Compass } from "lucide-react";
import { Reveal } from "@/components/motion";

const FLAGS = ["🇲🇺", "🇦🇪", "🇵🇹", "🇹🇭", "🇸🇬", "🇪🇸", "🇬🇷", "🇲🇹", "🇦🇺", "🇨🇦", "🇮🇩", "🇨🇷"];

export const LifeMatchTeaser = () => {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden bg-[#111827] px-5 py-24 md:py-28" data-testid="home-lifematch-teaser">
      {/* blue glow accents */}
      <div aria-hidden className="absolute -top-32 left-[-8%] h-[420px] w-[420px] rounded-full bg-[#2E8BFF]/20 blur-3xl" />
      <div aria-hidden className="absolute -bottom-40 right-[-6%] h-[380px] w-[380px] rounded-full bg-[#4DB8FF]/15 blur-3xl" />
      {/* floating flags backdrop */}
      <div aria-hidden className="pointer-events-none absolute inset-0 hidden select-none md:block">
        {FLAGS.map((f, i) => (
          <span
            key={i}
            className="absolute text-2xl opacity-[0.14]"
            style={{ left: `${(i * 83) % 96}%`, top: `${(i * 37) % 88}%`, transform: `rotate(${(i % 5) * 6 - 12}deg)` }}
          >
            {f}
          </span>
        ))}
      </div>

      <div className="relative mx-auto max-w-3xl text-center">
        <Reveal>
          <p className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#4DB8FF]">
            <Compass className="h-3.5 w-3.5" /> NOVA LifeMatch
          </p>
          <h2 className="mt-7 font-display text-3xl leading-tight text-white sm:text-4xl md:text-5xl">
            {t("lifematch.teaserTitle")}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm font-light leading-relaxed text-white/65 md:text-base">
            {t("lifematch.teaserText")}
          </p>
          <Link
            to="/lifematch"
            data-testid="home-lifematch-cta"
            className="mt-9 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#2E8BFF] to-[#4DB8FF] px-8 py-4 text-sm font-semibold text-white shadow-lg shadow-[#2E8BFF]/30 transition-transform duration-300 hover:scale-105"
          >
            {t("lifematch.cta")} <ArrowRight className="h-4 w-4" />
          </Link>
          <p className="mt-6 text-xs tracking-wide text-white/40">{t("lifematch.teaserMeta")}</p>
        </Reveal>
      </div>
    </section>
  );
};
